import React, { useEffect } from 'react'
import { providers } from "../../../constants/simple-cert";
import Method from "./Method";
import styled from "@emotion/styled";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { optionState, sessionState } from "../../../atom/common";
import { useNavigate } from 'react-router-dom';
import { providerState } from '../../../atom/simpleCert';
import { routes } from '../../../constants/routes';

const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: 14px;
    gap: 2%;
`;

const Box = styled.div`
    flex-wrap: wrap;
    margin-bottom: 16px;
    flex: 1 1 calc(25% - 2%); // 25% 너비에서 gap 고려
    box-sizing: border-box;
    max-width: 90px;
`;

export default function Methods() {
    const { provider_list } = useRecoilValue(sessionState);
    const { default_provider } = useRecoilValue(optionState);
    const setProvider = useSetRecoilState(providerState);
    const navigate = useNavigate();

    useEffect(() => {
        if (default_provider && provider_list?.includes(default_provider)) {
            setProvider(default_provider);
            navigate(routes.simpleCert.request);
        }
    }, [default_provider])

    return (
        <Container>
            {provider_list?.map(provider =>
                (<Box key={provider}> <Method id={provider} {...providers[provider]} /> </Box>))
            }
        </Container>
    )
}
